import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed } from '@angular/core';

import { BetBuilderNoOfColumns, EventOption } from '@frontend/sports/betting-offer/feature/model';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { RxFor } from '@rx-angular/template/for';

import { BetBuilderOptionComponent } from './bet-builder-option.component';
import { MarketHelpComponent } from './market-help/market-help.component';
import { OverUnderOptionGroupComponent } from './over-under-option-group.component';

@Component({
    selector: 'ms-bet-builder-over-under-option-group',
    templateUrl: './bet-builder-over-under-option-group.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RxFor, NgClass, MarketHelpComponent, BetBuilderOptionComponent, IconCustomComponent],
})
export class BetBuilderOverUnderOptionGroupComponent extends OverUnderOptionGroupComponent {
    visibleRows = computed(() => Math.ceil(this.visibleOptionGroups() / BetBuilderNoOfColumns.Double));

    isSingleRowOfOptions = () => {
        const group = this.optionGroup();
        return group && group.options.length === BetBuilderNoOfColumns.Double;
    };

    trackOption(index: number, option: EventOption): number {
        return option.id;
    }
}
